const inputs = new WeakMap();

const argMap = {
  'png': 'image/png',
  'gif': 'image/gif',
  'jpeg': 'image/jpeg'
}

export default {
  install(Vue) {
    Vue.directive('file-upload', {
      bind(el, binding) {
        const input = document.createElement('input');
        input.type = 'file';

        if(binding.arg) {
          const args = binding.arg.split(',');
          const fileTypes = args.map((arg) => argMap[arg]).join(',');
          input.accept = fileTypes;
        }

        input.onchange = e => {
          const file = e.target.files[0];
          binding.value(file);
        }

        el.addEventListener('click', () => {
          input.click();
        });

        inputs.set(el, input);
      },
      unbind(el) {
        const input = inputs.get(el);
        input.remove();
        inputs.delete(el);
      }
    })
  }
}
